export default __webpack_public_path__ + "static/media/doctor-avater.0c9e731d.png";